import { makeAutoObservable, runInAction } from "mobx";
import { esgReportBuilderStore } from "./esg-report-builder.store";

class ESGReportWorkflowStore {
  currentStep = 1;
  steps = [
    { id: 1, name: "Report Settings", key: "settings" },
    { id: 2, name: "Select Disclosures", key: "selection" },
    { id: 3, name: "Data Entry", key: "data" },
    { id: 4, name: "Review & Submit", key: "review" },
  ];

  showPreviewModal = false;
  showDiscardDialog = false;
  showExportDialog = false;
  showDelegateDisclosuresDialog = false;
  showCustomDisclosureDialog = false;
  reviewExportFramework = "All";

  expandedDisclosures = new Set();

  constructor() {
    makeAutoObservable(this);
  }

  get canGoNext() {
    switch (this.currentStep) {
      case 1:
        return true;
      case 2:
        return true;
      case 3:
        return true;
      case 4:
        return false;
      default:
        return false;
    }
  }

  get canGoPrevious() {
    return this.currentStep > 1;
  }

  get canSubmit() {
    return this.currentStep === 4;
  }

  nextStep = () => {
    if (this.currentStep < this.steps.length) {
      this.currentStep += 1;
      this.updatePathname();
    }
  };

  previousStep = () => {
    if (this.currentStep > 1) {
      this.currentStep -= 1;
      this.updatePathname();
    }
  };

  goToStep = (stepId) => {
    if (stepId >= 1 && stepId <= this.steps.length) {
      this.currentStep = stepId;
    }
  };

  setShowDelegateDisclosuresDialog = (v) =>
    (this.showDelegateDisclosuresDialog = v);
  setShowCustomDisclosureDialog = (v) => (this.showCustomDisclosureDialog = v);
  setShowPreviewModal = (v) => (this.showPreviewModal = v);
  setReviewExportFramework = (v) => (this.reviewExportFramework = v);

  updatePathname = () => {
    const { reportId, framework } = esgReportBuilderStore;

    const path = `/esg/report/${framework}/${this.currentStep}${reportId ? `?reportId=${reportId}` : ""}`;

    window.history.replaceState(null, "", path);
  };

  toggleExpandDisclosure = (code) => {
    if (this.expandedDisclosures.has(code)) {
      this.expandedDisclosures.delete(code);
    } else {
      this.expandedDisclosures.add(code);
    }
  };

  resetWorkflow = () => {
    runInAction(() => {
      this.currentStep = 1;
      this.showPreviewModal = false;
      this.showDiscardDialog = false;
      this.showExportDialog = false;
      this.showCustomDisclosureDialog = false;
      this.reviewExportFramework = "All";
      this.expandedDisclosures.clear();
    });
  };
}

export const esgReportWorkflowStore = new ESGReportWorkflowStore();
